let logger = null;

// TODO: RCV-38379 Make catcher save logs until rwc-logger is initialized
const log = (level, ...msg) => {
    if (!logger && window.rwcLogger) {
        logger = window.rwcLogger.byPrefix('vc:low:error-catch');
    }

    (logger || console)[level](...msg);
};

const captureException = error => {
    const sentryErrorReporterInstance = window[Symbol.for('sentryErrorReporterInstance')];
    sentryErrorReporterInstance?.captureException(error);
};

log('info', 'Initial location: ' + location.href);

/**
 * Handles global error events.
 *
 * @param {ErrorEvent} event - The event object representing an error.
 * @property {string} event.message - The error message.
 * @property {string} event.filename - The name of the file in which the error occurred.
 * @property {number} event.lineno - The line number where the error occurred.
 * @property {number} event.colno - The column number where the error occurred.
 * @property {Error} [event.error] - The actual error object (if available).
 * @see https://developer.mozilla.org/en-US/docs/Web/API/ErrorEvent
 */
window.addEventListener('error', event => {
    event.preventDefault?.();

    const errorOrMessage = event.error || event.message;

    captureException(errorOrMessage);

    const error = event.error || {
        message: event.message,
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
    };

    return log('error', 'UNCAUGHT_ERROR', error);
});

/**
 * @typedef {Event} PromiseRejectionEvent
 * @property {Promise<any>} promise - The promise that was rejected.
 * @property {any} reason - The reason why the promise was rejected.
 * @see https://developer.mozilla.org/docs/Web/API/PromiseRejectionEvent
 */
/**
 * Handles unhandled promise rejections.
 *
 * @param {PromiseRejectionEvent} event - The event object for unhandled promise rejections.
 * @see https://developer.mozilla.org/docs/Web/API/PromiseRejectionEvent
 */
window.addEventListener('unhandledrejection', event => {
    event.preventDefault?.();

    captureException(event.reason);

    return log('error', 'UNHANDLED_REJECTION', event.reason);
});
